import { BLOG_PATHNAME } from 'constants/blog';

export const isBlogPage = (pathname: string) => {
  return pathname.startsWith(`/${BLOG_PATHNAME}`);
};
